/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ForgotOrganizationMailRequestFromJSON(json) {
    return ForgotOrganizationMailRequestFromJSONTyped(json, false);
}
export function ForgotOrganizationMailRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        encryptedEmail: !exists(json, 'encrypted_email') ? undefined : json['encrypted_email']
    };
}
export function ForgotOrganizationMailRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        encrypted_email: value.encryptedEmail
    };
}
